import { PLACE_LIST_PROMOTION_BANNER_ONELINK_URL } from '@/features/seoPlaceSearch/lib/cta'
import { DividerHorizontal } from '@/shared/design-system/components'
import { SolidButton } from '@/shared/design-system/components/Button/Solid'
import { logEvent } from '@/shared/external/firebase/analytics'
import { useSeoOnelinkUrl } from '@/shared/external/onelink'
import { EVENT_NAMES, LABELS } from '@/shared/lib/analytics'

const PlaceSearchBanner = () => {
  const onelinkUrl = useSeoOnelinkUrl(PLACE_LIST_PROMOTION_BANNER_ONELINK_URL)

  const handleClick = () => {
    logEvent(EVENT_NAMES.WEB_VIEW.SEO.CLICK.SEARCH_ITEM, {
      label: LABELS.WEB_VIEW.SEO.CLICK.COUPON,
    })
    window.open(onelinkUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className='px-dimension-x5'>
      <div className='flex items-center justify-between py-dimension-x4'>
        <div className='flex items-center gap-dimension-x3'>
          <img
            src='https://mycle.co.kr/resources/images/2.0/logo/mycle_app_logo.svg'
            alt='마이클 로고'
            className='rounded-dimension-x2 shadow-[0_0_1px_0_rgba(0,0,0,0.06),0_2px_8px_0_rgba(0,0,0,0.08)]'
          />
          <p className='text-title-2-bold text-foreground-neutral-strong'>
            엔진오일 2만원 쿠폰 증정
          </p>
        </div>
        <SolidButton
          text='쿠폰받기'
          variant='brand'
          size='small'
          clickable={handleClick}
        />
      </div>
      <DividerHorizontal
        h='h-stroke-width-x1'
        color='bg-stroke-neutral-normal'
      />
    </div>
  )
}

export default PlaceSearchBanner
